// widget-parking-information.component.ts

import { Component, Input } from "@angular/core";

import { Router } from "@angular/router";

@Component({
	selector: "widget-parking-information",
	templateUrl: "./widget-parking-information.component.html",
	styleUrls: ["./widget-parking-information.component.scss"],
})
export class WidgetParkingInformationComponent {
	constructor(private router: Router) {}

	@Input() totalLots = 0;

	@Input() occupiedLots = 0;

	@Input() availableLots = 0;

	@Input() reusableLots = 0;

	goToParkingLot(type: string, event?: MouseEvent) {

		event.preventDefault();
	
		let queryParams: any = {};
	
		if (type === "occupied") {
	
			queryParams = {
				status: "occupied"
			};
		}
	
		else if (type === "available") {
	
			queryParams = {
				status: "available"
			};
		}
	
		else if (type === "reusable") {
	
			queryParams = {
				reusable: true
			};
		}
	
		const urlTree = this.router.createUrlTree(
			["/parkingLotMaster"],
			{
				queryParams
			}
		);
	
		const url =
			this.router.serializeUrl(urlTree);
	
		window.open(url, "_blank");
	}
}
